import stripHtml from '@/helpers/stripHtml';
import _getFieldNodes from '@/ui/ui_ajax-products/methods/getFieldNodes';

/**
 * @description
 * Формируем селектор вариантов, и вешаем необходимые классы в зависимости от переданного темплейта
 */

export default (variants, variantsSelectBlockNode, options, selectAttr) => {
  if (!variants || !variants.length || !variantsSelectBlockNode || !selectAttr) { return; }

  let variantsOptions = {};
  let variantsSelectData = variantsSelectBlockNode.dataset[selectAttr];
  if (variantsSelectData) {
    variantsOptions = JSON.parse(variantsSelectData);
  }

  const imagesSize = variants.map(item => item.image_id).filter(item => item);
  const variantSelectNodes = _getFieldNodes(variantsSelectBlockNode, 'select');

  if (variantSelectNodes.length) {
    let variantSelectNewData = null;
    if (imagesSize.length > 1) {
      for (const [ key, value ] of Object.entries(variantsOptions)) {
        if (key !== 'default') {
          variantsSelectBlockNode.classList.add(`ajax-product-variants-${value}`);
          variantSelectNewData = variantsSelectData;
        }
      }
    } else {
      variantSelectNewData = `{ "default": "${variantsOptions.default}" }`;
    }

    variantSelectNodes.forEach((selectNode) => {
      selectNode.dataset.productVariants = variantSelectNewData;

      if (options.hideVariants && options.hideVariants !== 'false') {
        const firstVariant = variants[0];
        selectNode.innerHTML += `<option value="${firstVariant.id}">${stripHtml(firstVariant.title)}</option>`;
      } else {
        variants.forEach((variant) => {
          selectNode.innerHTML += `<option value="${variant.id}">${stripHtml(variant.title)}</option>`;
        });
      }
    });
  }
};
